import React from "react";
import CheckboxFilter from "../Common/CheckboxFilter";
import { doorsData } from "../../../../data/category/inputData";

const Doors = () => {
  return (
    <CheckboxFilter title="Doors" filterData={doorsData} filterName="doors" />
  );
};

export default Doors;
